import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as json2csv from 'json2csv';

@Injectable({
    providedIn: 'root'
})
export class FileSaverService {

    date = new Date();
    timestamp;

    constructor() {}

    generateDownloadFile(res: any, heading: string) {
        const fileName = heading + ".json";
        const blob = new Blob([JSON.stringify(res)], { type: 'text/json;charset=utf-8' });
        FileSaver.saveAs(blob, fileName);
    }



    generateDownloadFileAsCsv(data: any, heading, fields?: any) {
        const opts = {fields};
        const json2csvParser = new json2csv.Parser(opts);
        const csvData = json2csvParser.parse(data);
        const fileName = heading + ".csv";
        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        FileSaver.saveAs(blob, fileName);
    }



    downloadFileAsCsv(data: any, heading) {
        this.timestamp = "_" + formatDate(this.date.toString(), 'shortDate', 'EN-US');
        const fileName = heading + this.timestamp  + ".csv";
        const blob = new Blob([data], { type: 'text/csv' });
        FileSaver.saveAs(blob, fileName);
    }



}
